module.exports = __webpack_public_path__ + "static/media/ic_fin_tools_fhc.c14fd807.svg";